module.exports = __webpack_public_path__ + "static/media/sig.0c5456cd.gif";